

import React, { memo } from 'react';
import CommentTextEditor from '../../../../../../CommentTextEditor';
import ContentView from '../../../../../../../../ContentView';
import '../styles/_comment-content.scss';














function Content({
  editMode,
  content,
  assetIds,
  editorState,
  onUpdateContent,
  onSave,
  onCancel,
  commentId,
  onFilesChange,
  resourceOrganisationId
}) {
  return (
    <div className="comment-content">
      {
      editMode ?

      <div className="comment-content__editor">
              <CommentTextEditor
          editorState={editorState}
          onUpdateContent={onUpdateContent}
          onSave={onSave}
          onCancel={onCancel}
          assetIds={assetIds}
          commentId={commentId}
          onFilesChange={onFilesChange}
          organisationId={resourceOrganisationId}
          canAddAsset
          canDeleteAsset />

            </div> :

      <ContentView content={content} showAssets />}

    </div>);

}

export default memo(Content);